import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/providers/actions';

import MenuLink  from 'components/Navigation/MenuLink';

import ActionDelete from 'material-ui/svg-icons/action/delete';

import { Page, PageBlock, RightDrawer } from 'components/Page';

import Subheader from 'material-ui/Subheader';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
import ClickableRowColumn from 'components/Grid/ClickableRowColumn';
import ClickableRow from 'components/Grid/ClickableRow'


import RaisedButton from 'material-ui/RaisedButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import * as os from 'osutil';

class ProviderPage extends Component {
    state = { selected: [] };

    static contextTypes = {
        router: PropTypes.object
    };
    
    componentWillMount() {
        this.props.fetchProviders();
    }

    handleDeleteClick = (id) => {
        this.props.deleteProvider(id);
    }

    handleEditClick = (id) => {
        this.context.router.history.push("/admin/provider/"+id);
    }

    addProvider = (e) => {
        this.props.createProvider({name:"New provider"}, this.handleEditClick);
    }

    deleteProviders = (e) => {
        _.each(this.state.selected, (p => this.props.deleteProvider(p.key) ))
    }

    onRowSelection = (rows) => {
        var selected = rows.map( i => this.props.providers[i]).filter( r => !!r );
        this.setState({selected: selected});
    }


    renderProviders() {
        return _.map(this.props.providers, (provider) => {

            return (
                <ClickableRow key={provider.key} onMyRowClick={ () => this.handleEditClick(provider.key) }>
                    <ClickableRowColumn>{provider.name}</ClickableRowColumn>
                    <ClickableRowColumn>{provider.description}</ClickableRowColumn>
                    <ClickableRowColumn>{provider.url}</ClickableRowColumn>        
                </ClickableRow>
            );
        });
    }
    render() {

        return [
            <RightDrawer key="right">
              <PageBlock label="Leverantör">
              <div>
                    {this.state.selected.length ? 
                     <RaisedButton mini secondary onClick={this.deleteProviders}>
                         <ActionDelete />
                     </RaisedButton>
                     : ''}
                <RaisedButton onClick={this.addProvider}>
                    Skapa ny
                </RaisedButton>
                </div>
                </PageBlock>
            </RightDrawer>,
            <Page key="page" ready={!this.props.pending}>
                <Subheader>
	            <MenuLink label="Providerer" to="/admin/providers"/>
                </Subheader>

                <Table multiSelectable onRowSelection={this.onRowSelection}>
                    <TableHeader displaySelectAll={false}>
                        <TableRow>
                            <TableHeaderColumn>Namn</TableHeaderColumn>
                            <TableHeaderColumn>Beskrivning</TableHeaderColumn>
                            <TableHeaderColumn>URL</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody deselectOnClickaway={false}>
                        {this.renderProviders()}
                    </TableBody>
                </Table>
                
                
            </Page>
        ]
    }
}

function mapStateToProps(state) {
    return { 
        providers: os.collection_to_array(state.providers.list.data),
        pending: state.providers.list.pending,
    };
}

export default connect(mapStateToProps, actions)(ProviderPage)





// WEBPACK FOOTER //
// ./src/pages/admin/providers/Providers.jsx